export const MS_PER_DAY = 86_400_000;

function today0(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function relDayToISO(rel: number | null | undefined): string | null {
  if (rel == null) return null;
  const d = today0();
  d.setDate(d.getDate() + rel);
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

export function isoToRelDay(iso: string | null | undefined): number {
  if (!iso) return 0;
  const then = new Date(iso + "T00:00:00");
  then.setHours(0, 0, 0, 0);
  return Math.round((then.getTime() - today0().getTime()) / MS_PER_DAY);
}

const MONTHS_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export function formatPlantedOn(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso + "T00:00:00");
  if (isNaN(d.getTime())) return null;
  const month = MONTHS_SHORT[d.getMonth()];
  const pretty = `${month} ${d.getDate()}, ${d.getFullYear()}`;
  const days = Math.floor((today0().getTime() - d.getTime()) / MS_PER_DAY);
  let age: string;
  if (days < 0) age = "in the future";
  else if (days === 0) age = "today";
  else if (days < 30) age = `${days}d ago`;
  else if (days < 365) age = `${Math.floor(days / 30)}mo ago`;
  else age = `${Math.floor(days / 365)}y ago`;
  return `${pretty} · ${age}`;
}
